import { devlog } from '@ping/utils';

export const log = {
  chart: devlog('chart<-', { hexColor: '#3CCB7F' }),
  state: {
    in: devlog('state<-', { hexColor: '#FAC515' }),
    out: devlog('state->', { hexColor: '#EAAA08' }),
  },
} as const;
